
export default {
  getOptionalPositions () {
    const s = [{ name: 'Assistant Scribe', key: '6' },
      { name: 'Photographer', key: '7' },
      { name: 'Asst. Senior Patrol Leader', key: '9' },
      { name: 'Religious Coordinator', key: '10' },
      { name: 'Asst. Quartermaster', key: '12' },
      { name: 'Cook', key: '13' },
      { name: 'Asst. Cook', key: '14' },
      { name: 'Cook Staff', key: '15' },
      { name: 'Other', key: '17' },
      { name: 'Unassigned', key: '18' },
      { name: 'Mentor', key: '19' }]
    return s
  }
}
